import { HCP } from '../constants'
import StaticConfig from '../mi-app/StaticConfig'
import { api } from '../mi-app/index.api'
import { PERMISSIONS } from '../constants'

/*
* This is used to initialize reference data in Redux store at the time user logs into the site.
*/
export const initializeReferenceData = (selectedCountry, userType, selectedLanguage, actionDispatchers, isConference, callback = null) => {
  const countryAffiliate = selectedCountry.affiliate
  const countryName = selectedCountry.name

  if (selectedLanguage) {
    actionDispatchers.switchLanguage(selectedLanguage, selectedCountry.abbrevation.toLowerCase())
  }
  const queryParams = {
    affiliate: countryAffiliate,
    userType,
    country: countryName,
    language: selectedLanguage,
    isConference
  }
  const permissionQueryParams = {
    userType,
    country: countryName
  }

  // Callback to be executed after API results are returned, but before state updates.  Used to close the login modal.
  if (callback) {
    const referenceData = api.getAllReferenceData(queryParams, (response) => response)
    const permissions = api.getPermissions(permissionQueryParams, (response) => response)
    permissions.then(permissionsResponse => referenceData.then(referenceDataResponse => {
      callback()
      _getAllReferenceDataSuccessHandler(userType, selectedCountry, selectedLanguage, actionDispatchers, referenceDataResponse)
      _permissionSuccessHandler(actionDispatchers, selectedLanguage, permissionsResponse, userType)
    }))
  } else {
    api.getAllReferenceData(queryParams, (response) => _getAllReferenceDataSuccessHandler(userType, selectedCountry, selectedLanguage, actionDispatchers, response))
    api.getPermissions(permissionQueryParams, (response) => _permissionSuccessHandler(actionDispatchers, selectedLanguage, response, userType))
  }
}

const _getAllReferenceDataSuccessHandler = (userType, selectedCountry, selectedLanguage, actionDispatchers, referenceData) => {
  const products = referenceData.PRODUCT_MASTER
  const sortedProducts = products.sort(function (p1, p2) {
    return p1.name.localeCompare(p2.name)
  })

  const acceptedFileExtensions = referenceData.ACCEPTED_FILE_TYPE && referenceData.ACCEPTED_FILE_TYPE.length 
    ? referenceData.ACCEPTED_FILE_TYPE.map(type => type.extension).join(', ') 
    : ''

  const refData = {
    ApplicationConfig: referenceData.APPLICATION_CONFIG,
    MenuConfig:referenceData.MENU_CONFIGURATION,
    AmiDigitalAssistant: referenceData.AMI_DIGITALASSISTENT,
    MedicalSpeciality: referenceData.MEDICAL_SPECIALITY,
    DeliveryMethods: referenceData.DELIVERY_METHOD,
    RequestorTypes: referenceData.REQUESTOR_TYPE,
    UserType: userType,
    SelectedLanguage:  selectedLanguage,
    indicators: referenceData.INDICATION,
    ProductMaster: sortedProducts,
    Salutation: referenceData.SALUTATION,
    SelectedCountry: selectedCountry,
    Search: !((referenceData.COMPONENT_CONFIG[0].externalSelfServiceActive === 0 && userType === HCP)),
    acceptedFileExtensions: acceptedFileExtensions,
    brandNameGenericProducts: referenceData.PRODUCT_BRAND_AND_GENERIC
  }
  StaticConfig.Context.ComponentConfig = referenceData.COMPONENT_CONFIG[0]
  StaticConfig.Context.Country = selectedCountry
  StaticConfig.Context.UserType = userType
  StaticConfig.Context.searchProductList = referenceData.PRODUCT_MASTER
  actionDispatchers.referenceData(refData)
  actionDispatchers.selectedCountry(selectedCountry)
  return referenceData
}

const _permissionSuccessHandler = (actionDispatchers, selectedLanguage, permissions, userType) => {
  let filteredPermissions = permissions;
  actionDispatchers.setPermissionAction(filteredPermissions, selectedLanguage, userType)
  return filteredPermissions
}



// WEBPACK FOOTER //
// ./src/helpers/InitializeStoreData.js